import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import d2Tree from './comp/d2Tree.vue';
var initForm = {};
export default {
  meta: {
    title: '员工管理',
    auth: true,
    authorityValue: "store-account-management"
  },
  name: 'staff',
  components: {
    d2Tree: d2Tree
  },
  data: function data() {
    return {
      initForm: initForm,
      form: cloneDeep(initForm),
      request: {
        api: 'staffList',
        params: cloneDeep(initForm)
      },
      positions: []
    };
  },
  mounted: function mounted() {
    this.callAdminPositions();
  },
  methods: {
    handleSearch: function handleSearch(values) {
      this.$set(this.request, 'params', values);
      this.$refs.baseTable.loadData();
    },

    /** 角色列表 */
    callAdminPositions: function callAdminPositions() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$_this$$api$pos, records;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$api.positions({
                  pageSize: 1000 * 1000
                });

              case 3:
                _yield$_this$$api$pos = _context.sent;
                records = _yield$_this$$api$pos.records;
                _this.positions = records === null || records === void 0 ? void 0 : records.map(function (item) {
                  return _objectSpread(_objectSpread({}, item), {}, {
                    label: item.positionName,
                    value: item.positionId
                  });
                });
                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 8]]);
      }))();
    },
    isActive: function isActive(row) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this2.$confirm('是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.next = 2;
                          return _this2.$api.lock({
                            accountId: row.accountId
                          });

                        case 2:
                          _this2.handleSearch();

                          YL.message('操作成功');

                        case 4:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2);
                })));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    toDel: function toDel(id) {
      var _this3 = this;

      this.$confirm('确定删除该账号吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this3.$api.deleteStaff({
                  accountId: id
                });

              case 2:
                _this3.$message({
                  type: 'success',
                  message: '删除成功!'
                });

                _this3.handleSearch();

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))).catch(function () {});
    },
    download: function download() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _yield$_this4$$api$st, records, columns, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this4.$api.staffList(_objectSpread(_objectSpread({}, _this4.form), {}, {
                  pageSize: 99999
                }));

              case 2:
                _yield$_this4$$api$st = _context6.sent;
                records = _yield$_this4$$api$st.records;
                columns = [{
                  label: '登录账号',
                  prop: 'loginAccount'
                }, {
                  label: '员工姓名',
                  prop: 'accountName'
                }, {
                  label: '搭配角色',
                  prop: 'positionName'
                }, {
                  label: '添加时间',
                  prop: 'createTime'
                }, {
                  label: '状态',
                  prop: 'loginActivated'
                }];
                data = [];
                records.forEach( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(v) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            _this4.$set(v, 'loginActivated', v.loginActivated ? '停用' : '启用');

                            data.push(v);

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x) {
                    return _ref3.apply(this, arguments);
                  };
                }());

                _this4.xlsxExport(columns, data, '员工管理');

              case 8:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    }
  }
};